import Vue from 'vue'
import service from '../services/shelterFeeService.js'

export function useShelterFee() {
    const state = Vue.observable({
        items: [],
        currentPage: 1,
        lastPage: 1,
        loading: false
    })

    async function getReports(params = {}) {
        state.loading = true
        try {
            const data = await service.getReports(params)
            state.items = data.current_page === 1 ? [...data.data] : [...state.items, ...data.data]
            state.currentPage = data.current_page
            state.lastPage = data.last_page
            return { success: true, data }
        } catch (err) {
            return { success: false, error: err }
        } finally {
            state.loading = false
        }
    }

    async function getClients() {
        state.loading = true
        try {
            const data = await service.getClients()
            return { success: true, data }
        } catch (err) {
            return { success: false, error: err }
        } finally {
            state.loading = false
        }
    }

    return { state, getReports,getClients }
}
